import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20reading%20experience%20on%20smartphone%2C%20vertical%20scroll%20comic%20display%2C%20modern%20minimal%20setup%2C%20warm%20ambient%20lighting%2C%20cozy%20reading%20environment%2C%20digital%20art%20display%2C%20clean%20composition%2C%20soft%20warm%20tones%2C%20lifestyle%20photography%20style&width=1400&height=600&seq=cta-reading-01&orientation=landscape"
            alt="下拉式阅读体验"
            title="下拉式阅读体验 - 韩国漫画网"
            className="w-full h-[300px] md:h-[420px] object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/20 to-transparent" />
        </div>

        <div className="text-center mt-10 md:mt-14">
          <p className="text-xl md:text-3xl font-heading text-foreground-900 leading-relaxed">
            在<span className="font-bold text-foreground-950">下拉式阅读</span>中
          </p>
          <p className="text-xl md:text-3xl font-heading text-foreground-900 leading-relaxed mt-2">
            感受<span className="italic text-foreground-600">流畅自然</span>的韩漫阅读体验
          </p>

          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 mt-8 px-10 py-4 bg-foreground-950 text-background-50 font-medium text-sm rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即体验下拉式阅读
            <i className="ri-arrow-down-line text-base" />
          </Link>
        </div>
      </div>
    </section>
  );
}